import { getChildDeep as o } from "react-nanny";
const s = (n, t) => o(n, (r) => {
  var e;
  if ((e = r == null ? void 0 : r.props) != null && e.children) {
    if (r.props.__TYPE && r.props.__TYPE === t)
      return !0;
  } else if (String(r == null ? void 0 : r.type).match(t))
    return !0;
});
export {
  s as findChild
};
